module.exports = __webpack_public_path__ + "static/media/private-user-pin-inactive.6810795a.svg";